/* 🤖 this file was generated by svg-to-ts */
export const matIconNumbers: {
  name: 'numbers';
  data: string;
} = {
  name: 'numbers',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m20.5 10 .5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4zm-7 4h-4l1-4h4l-1 4z"/></svg>`
};
